export const asId = (value) => {
  if (value === null || value === "") return "";
  if (typeof value === "string") return value;
  if (typeof value === "object") {
    if (typeof value.toHexString === "function") return value.toHexString();
    if (value._id) return asId(value._id);
    if (typeof value.id === "string") return value.id;
    if (value.type === "Buffer" && Array.isArray(value.data)) {
      return value.data.map((byte) => Number(byte).toString(16).padStart(2, "0")).join("");
    }
  }
  const asString = String(value);
  return /^[a-fA-F0-9]{24}$/.test(asString) ? asString : "";
};

export const idsEqual = (left, right) => {
  const a = asId(left);
  const b = asId(right);
  return Boolean(a) && a === b;
};
